<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="show"
      max-width="600"
      @input="v => v || closeDialog()"
    >
      <v-card>
        <v-card-title class="card-title">
          <span class="headline white--text text-uppercase">Create Account</span>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container fluid>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="userId"
                    type="number"
                    label="userId"
                    :rules="requiredRule"
                    single-line
                    box
                    required
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="iban"
                    type="text"
                    label="IBAN"
                    :rules="requiredRule"
                    single-line
                    box
                    required
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="bic"
                    type="text"
                    label="BIC"
                    :rules="requiredRule"
                    single-line
                    box
                    required
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <v-alert
            v-if="createAccountError"
            :value="true"
            type="error"
            class="my-3"
          >
            {{ createAccountError }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="cancelAction()"
          >
            cancel
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="createAccountCreation()"
          >
            create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

import { mapActions } from 'vuex';

export default {
  name: 'CreateAccount',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    createAccountError: {
      type: String,
      default: '',
    },
    processing: {
      type: Boolean,
      default: false,
    },
    submitAction: {
      type: Function,
      default: () => ({}),
    },
    cancelAction: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: true,
      show: this.dialog,
      userId: null,
      iban: null,
      bic: null,
      requiredRule: [
        v => !!v || 'field is required',
      ],
    };
  },
  watch: {
    dialog(val) {
      this.show = val;
    },
    data(val) {
      this.userId = val.userId;
      this.iban = val.iban;
      this.bic = val.bic;
    },
  },
  methods: {
    ...mapActions([
      'fetchUserIdentificationFiles',
      'fetchUserDetails',
    ]),
    async createAccountCreation() {
      if (this.$refs.form.validate()) {
        const userDetails = await this.fetchUserDetails(this.userId);
        if (userDetails.identData.identified === false) {
          this.createAccountError = 'No ident case for this user';

          return;
        }
        this.submitAction(
          this.requestData(userDetails.userData, this.iban, this.bic),
        );
      }
    },
    closeDialog() {
      this.cancelAction();
    },
    requestData(userData, iban, bic) {
      return {
        user_id: this.userId,
        IBAN: iban,
        BIC: bic,
        Gender: userData.sex === 'male' ? 'M' : 'F',
        Title1: userData.title,
        FirstName: userData.first_name,
        LastName: userData.last_name,
        BirthName: userData.birth_name,
        DateOfBirth: this.$moment(userData.dob).format('YYYY-MM-DD'),
        PlaceOfBirth: userData.pob,
        CountryOfBirth: userData.country_of_birth,
        Citizenship: userData.citizenship,
        MaritalStatus: userData.marital_status,
        Street: userData.street,
        StreetNo: userData.street_no,
        StreetNoAdditional: userData.street_additional,
        PostalCode: userData.postal_code,
        Town: userData.city,
        Country: userData.country,
        Phone: userData.phone,
        Mobile: userData.phone_mobile,
        Email: userData.email,
        PolticallyExposedPerson: userData.pep,
        SelfEmployed: 0,
        Industry: '',
        WpHGQuestionnaire: 'N',
        ChurchTaxDeduction: userData.church_tax_deduction,
        USTaxLiability: userData.not_us_taxed ? 0 : 1,
        TaxIDOne: userData.tax_id,
        TaxCountryOne: userData.country,
        LegDocumentType: userData.legitimation_document,
        LegDocumentNumber: userData.pass,
        LegDateOfExpiry: this.$moment(userData.pass_expires_at).format('YYYY-MM-DD'),
        LegDateOfIssue: this.$moment(userData.pass_created_at).format('YYYY-MM-DD'),
        LegIssuingAuthority: userData.pass_authority,
        LegIssuingAuthorityCountry: userData.pass_country_of_issue,
        NationalClientIdentifierCountry: userData.citizenship,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  .saldo-info {
    width: 90%;
    margin: 5px auto auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/baader/CreateAccount.vue